import React from 'react';

import { EnterpriseSelector } from '@fastlessjs/backoffice-layer/dist/components/molecules';

import { ExtraHeaderInfos } from './extraHeaderComponents/extraHeaderInfos';

const ExtraHeaders = [
  {
    id: 'extra-header-infos',
    component: <ExtraHeaderInfos />,
    isVisible: true,
  },
  {
    id: 'enterprise-selector',
    component: <EnterpriseSelector />,
    isVisible: true,
  },
];

export { ExtraHeaders };
